import { useCallback } from 'react';
import { FormDropdownInputComponent } from 'src/features/generalForms/builder/types/DropdownInput';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { RPDF } from 'src/features/report/react-pdf';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';

export const FormDropDownInput: FormDropdownInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const renderValue = useCallback(
    (v: string) =>
      props.options
        ?.filter((opt) => opt.key === v)
        .map((opt) => opt.value)
        .join(', ') ?? '',
    [props.options],
  );

  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <RPDF.View />;
  }

  return <AnswerPreviewRow<string> value={value} renderValue={renderValue} {...props} />;
};
